import { ReactChild } from 'react'
import { TextLegacy } from '@/components/common'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'

const RenderNewlineText = ({ value }: { value: string }) => {
  // @ts-ignore
  return <div style={{ 'white-space': 'pre-line' }}>{value}</div>
}

const PolicyPrivacyPurpose = ({
  fontSize = { xs: 12, md: 14 },
  strongFontSize = { xs: 14, md: 16 },
  paddingTop = 40,
}: {
  fontSize?: FontResponsiveSizeType
  strongFontSize?: FontResponsiveSizeType
  paddingTop?: number
}) => {
  const columnsOrderPrivacy = [
    {
      title: '서비스',
      dataIndex: 'service',
      key: 'service',
      width: '12%',
      render: (value: string) => <RenderNewlineText value={value} />,
    },
    {
      title: '세부 서비스',
      dataIndex: 'serviceDetail',
      key: 'serviceDetail',
      width: '18%',
      render: (value: string) => <RenderNewlineText value={value} />,
    },
    {
      title: '수집 목적',
      dataIndex: 'purpose',
      key: 'purpose',
      width: '23%',
      render: (value: string) => <RenderNewlineText value={value} />,
    },
    {
      title: '수집 항목',
      dataIndex: 'item',
      key: 'item',
      width: '23%',
      render: (value: string) => <RenderNewlineText value={value} />,
    },
    {
      title: '보유 및 이용기간',
      dataIndex: 'period',
      key: 'period',
      width: '24%',
      render: (value: ReactChild, _record: any) => {
        const children = typeof value === 'string' ? <RenderNewlineText value={value} /> : value
        return { children }
      },
    },
  ]
  const dataSourceOrderPrivacy = [
    {
      key: 1,
      service: '핏펫몰',
      serviceDetail: '회원가입 및 관리',
      purpose:
        '회원 가입의사 확인, 회원제 서비스 제공에 따른 본인식별∙인증, 연령인증, 회원자격 유지∙관리, 서비스 부정이용 방지, 각종 고지∙통지',
      item: '- 이메일, 이름, 휴대폰 번호, SNS간편가입 업체의 사용자별 고유키(SNS간편가입시)',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            회원 탈퇴 후 3개월까지
          </TextLegacy>
          <br />
          ※단, 관계법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시까지
        </>
      ),
    },
    {
      key: 2,
      service: '핏펫몰',
      serviceDetail: '반려동물 상담 및 병원연계 서비스',
      purpose: '상담 서비스 제공, 병원 연계 진행, 반려동물 정보 확인',
      item:
        '- 회원 정보 : 성명, 생년월일, 성별, 휴대전화번호\n' +
        '- 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            회원 탈퇴시까지
          </TextLegacy>
          <br />
          ※단, 법정 의무 보유기간에 따라 보관
        </>
      ),
    },
    {
      key: 3,
      service: '핏펫몰',
      serviceDetail: '병원예약 서비스',
      purpose: '병원예약 서비스 진행',
      item:
        '- 회원 정보 : 이름, 휴대전화번호, 생년월일 \n' +
        '- 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            회원 탈퇴시까지
          </TextLegacy>
          <br />
          ※단, 법정 의무 보유기간에 따라 보관
        </>
      ),
    },
    {
      key: 4,
      service: '핏펫몰',
      serviceDetail: '핏펫몰 서비스',
      purpose: '상품(서비스) 배송(전송), 반품, 환불, 고객상담 등 구매계약의 이행을 위해 필요한 업무의 처리',
      item:
        '- 구매자 정보(이메일, 이름, 휴대폰 번호), 수취인 정보(이름, 휴대폰 번호, 배송주소), 주문정보\n' +
        '- 신용카드 결제 시 : 카드사명, 카드번호 \n' +
        '- 계좌이체 시 : 예금주명. 계좌번호, 은행명 \n' +
        '- 휴대폰 결제 시 : 통신사, 휴대폰번호',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            동의철회 또는 회원 탈퇴시까지
          </TextLegacy>
          <br />
          ※단, 법정 의무 보유기간에 따라 보관
        </>
      ),
    },
    {
      key: 5,
      service: '핏펫몰',
      serviceDetail: '고충처리',
      purpose: '이용자의 신원 확인, 고충사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보',
      item: '이름, 휴대폰 번호, 이메일, 배송주소, 상담 내용, 주문 정보',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            회원 탈퇴시까지
          </TextLegacy>
          <br />
          ※단, 법정 의무 보유기간에 따라 보관
        </>
      ),
    },
    {
      key: 6,
      service: '핏펫몰',
      serviceDetail: '회원 등급 산정 및 혜택 제공',
      purpose: '최근 3 개월 실결제 금액 기준 등급 산정, 등급별 차등 혜택(배송비 할인 쿠폰 등) 제공',
      item: '[필수]\n구매이력\n(결제일자, 결제금액)\n회원 등급 정보',
      period: (
        <>
          <TextLegacy
            size={strongFontSize}
            style={{
              display: 'inline',
              fontWeight: 'bold',
              textDecoration: 'underline',
              textUnderlinePosition: 'under',
            }}
          >
            회원 탈퇴시까지
          </TextLegacy>
          <br />
          ※단, 법정 의무 보유기간에 따라 보관
        </>
      ),
    },
  ]

  return (
    <div style={{ padding: 10, paddingTop: paddingTop }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {
          '주식회사 핏펫은 아래의 목적으로 개인정보를 수집∙이용 및 제3자에게 제공하며, 회원의 소중한 개인정보를 보호함으로써 안심하고 서비스를 이용할 수 있도록 최선을 다합니다.\n\n'
        }
      </TextLegacy>
      <Table data={dataSourceOrderPrivacy} columns={columnsOrderPrivacy} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'귀하는 위의 개인정보 수집∙이용에 대해 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 회원가입이 어려울 수 있습니다.\n' +
          '위와 같이 개인정보를 수집∙이용하는 것에 동의하십니까?\n'}
      </TextLegacy>
    </div>
  )
}

export default PolicyPrivacyPurpose
